export const LOGIN_API = "Login API";
export const CONFIG_API = 'config api'

